import { RouteConfig } from 'vue-router';
const List = () => import('./views/list.vue');
const routers: RouteConfig[] = [
    {
        path: 'list',
        component: List,
    },
    {
        path: '*',
        redirect: 'list'
    },
];
export default routers;